import { Component, Input, OnInit } from '@angular/core';
import { Client, ProductGroup } from '@app/core/models/client';
import { WireClass } from '@app/core/models/message';
import { BannerPreviewComponent } from '../banner-preview/banner-preview.component';
import { FormsModule } from '@angular/forms';
import { SafeHtmlPipePipe } from '../../pipes/safe-html.pipe';

@Component({
    selector: 'sign-up-preview',
    templateUrl: './sign-up-preview.component.html',
    styleUrls: ['./sign-up-preview.component.scss'],
    standalone: true,
    imports: [BannerPreviewComponent, FormsModule, SafeHtmlPipePipe]
})
export class LoginPreviewComponent implements OnInit {
  @Input() productGroup: ProductGroup;
  @Input() client: Client;

  wire: WireClass;
  viewProductInfo: boolean = false;

  constructor() { }

  ngOnInit() {
    this.wire = new WireClass();
    this.wire.text = "";
    this.wire.actions = [];
  }

}
